const animation = {
  "ani_01_title": "<span>A fusion of </span><span><em>art, science </em></span><span>and </span> <span><em>innovation</em></span>",
  "ani_02_title": "<span><em>State-of-the-art </em></span><span>Lacreon® </span><span>technology</span>",
  "ani_03_title": "<span>Barely-there </span><span><em>invisible </em></span><span>edge&nbsp;design</span>",
  "ani_04_title": "<span><em>Science-backed </em></span><span><em>credibility </em></span><span>you can&nbsp;trust</span>",
  "ani_01_content": "Scientifically designed and artistically handcrafted to harmonise with your eyes. Craft your own beautiful with Define®.",
  "ani_02_content": "Designed to create lasting moisture cushion for 20 hours or more to help deliver all-day comfort.",
  "ani_03_content": "Thin, tapered lens edge design so your eyelids glide over like nothing's there.",
  "ani_04_content": "Enjoy quality contact lenses designed for safety and peace of mind with the world's leading contact lens brand.",
}

export default animation
